import { Link } from "react-router";
import { config } from "@/config";
import { navLinks } from "@/routes";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-bg-alt">
      <div className="container-page py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <Link to="/" className="inline-block no-underline">
              <img
                src="/SGI-Logo-New.png"
                alt={config.APP_NAME}
                className="h-20 w-auto rounded-sm"
              />
            </Link>
            <p className="mt-3 text-sm text-text-muted">
              Strategic business solutions that drive measurable growth and
              sustainable value for mid-market companies.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-text">Navigation</h3>
            <ul className="mt-3 space-y-2">
              {navLinks.map(({ path, label }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="text-sm text-text-muted hover:text-brand"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-text">Contact</h3>
            <p className="mt-3 text-sm text-text-muted">
              Ready to learn more? Reach out to discuss how we can drive value
              for your business.
            </p>
            <Link to="/contact" className="btn-primary mt-4 text-xs">
              Get in Touch
            </Link>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-8">
          <p className="text-xs leading-relaxed text-text-muted">
            <strong>Disclaimer:</strong> This website is for informational
            purposes only and does not constitute an offer to sell or a
            solicitation of an offer to buy any securities. Any offerings are
            made only to accredited investors pursuant to applicable exemptions
            under federal and state securities laws. Past performance is not
            indicative of future results. All investments involve risk,
            including the potential loss of principal.
          </p>
          <p className="mt-4 text-xs text-text-muted">
            &copy; {year} {config.APP_NAME}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
